import { AxiosRequestConfig } from 'axios';

const endpoint = 'api/keycloak';

export default {
    inviteUser: (data: any) => ({ method: 'POST', url: `${endpoint}/create`, data } as AxiosRequestConfig),
};
